import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../../assets/scss/components/RoleSelectorModal.scss';

const RoleSelectorModal = () => {
  const { user, selectedRole, changeRole, showRoleSelector, setShowRoleSelector } = useAuth();
  const [tempSelectedRole, setTempSelectedRole] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (selectedRole) {
      setTempSelectedRole(selectedRole);
    }
  }, [selectedRole]);

  if (!showRoleSelector || !user || !user.roles || user.roles.length === 0) {
    return null;
  }

  const handleRoleSelect = (role) => {
    setTempSelectedRole(role);
  };

  const handleConfirm = () => {
    if (tempSelectedRole) {
      changeRole(tempSelectedRole);
      setShowRoleSelector(false);
      
      // Redirigir al dashboard correspondiente
      navigate('/dashboard');
    }
  };

  const handleCancel = () => {
    // Si cancela, mantener el rol actual
    setTempSelectedRole(selectedRole);
    setShowRoleSelector(false);
  };

  return (
    <div className="role-selector-overlay">
      <div className="role-selector-modal">
        <div className="role-selector-header">
          <h2>Selecciona tu rol</h2>
          <p>Como usuario de nuestra plataforma, tienes acceso a los siguientes roles:</p>
        </div>

        <div className="role-selector-body">
          {user.roles.map((role) => (
            <div
              key={role.id}
              className={`role-card ${tempSelectedRole?.id === role.id ? 'selected' : ''}`}
              onClick={() => handleRoleSelect(role)}
            >
              <div className="role-card-header">
                <div className="role-radio">
                  <input
                    type="radio"
                    name="role"
                    checked={tempSelectedRole?.id === role.id}
                    onChange={() => handleRoleSelect(role)}
                  />
                </div>
                <div className="role-info">
                  <h3>{role.name}</h3>
                  <span className="role-code">{role.role_code}</span>
                </div>
              </div>
              
              <p className="role-description">{role.description}</p>
              
              {role.id === user.primary_role?.id && (
                <span className="role-badge">Rol Principal</span>
              )}
            </div>
          ))}
        </div>

        <div className="role-selector-footer">
          {user.roles.length > 1 && (
            <button
              className="btn-cancel"
              onClick={handleCancel}
              type="button"
            >
              Cancelar
            </button>
          )}
          <button
            className="btn-confirm"
            onClick={handleConfirm}
            disabled={!tempSelectedRole}
            type="button"
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoleSelectorModal;
